/**
 * Spanish (es) mappings for TopChatBanner
 * Simple key-value pairs for easy maintenance
 */

export const topChatBannerES = {
  // Button labels
  "AI Toolkit": "Kit IA",
  "Pick Slip": "Boleto",
  "Game Explorer": "Explorador de Juegos",

  // Response modes
  "Standard": "Estándar",
  "Quick": "Rápido",
  "Detailed": "Detallado",

  // Version
  "v2": "v2",

  // Pick slip counter - we'll handle the number dynamically
  "picks": "apuestas",

  // AI Prediction button
  "AI Prediction": "Predicción IA",
  "spin": "giro",
  "spins": "giros"
};
